'use client'
import React, { useContext, useEffect, useRef, useState } from "react";

import moment from "moment";
import { AuthContext } from "@/context/authContext";
import defaultThumbnail from "@/public/image/etc/default_thumnail.png"
import BoardListInfo from "@/components/etc/boardListInfo"
import { with_comma } from "@/util/comma";
import getThumbnail from "@/util/getThumbnail";
import EditView from "./edit";
import { editPageTypes } from "@/type/edit";
import Lottie from "react-lottie-player";
import loadingJson from "@/public/media/load_data.json"
import { useTranslations } from "next-intl";

{/* 기본 */}
{/* <ListV2 list={list} 
        setContent={setContent} 
        post={post}
        fetchData={setfetchData}
        type={"thumbnail"} /> */}

{/* 커스텀용 */}
{/* 
<ListV2 list={list}
    setContent={setContent}
    keyExtractor={(it) => it.id}
    renderItem={(it) => (
        <div className={``} onClick={()=>{}}>
            <div>커스텀용 : {it.title}</div>
        </div>
    )} /> 
     
<ListV2 list={list} setContent={setContentFunc}>
    {(item: any, idx: number) => (
        <div className="my-card">
        <h4>자식형 커스텀 : {item.title}</h4>
        </div>
    )}
</ListV2> 

*/}
export interface ListV2Props extends Omit<React.HTMLAttributes<HTMLUListElement>, 'children'> {
    type?: "default" | "gallery" | "thumbnail" | "image";
    list: any[];
    setContent: (id: any) => void;

    renderItem?: (item: any, index: number) => React.ReactNode;
    keyExtractor?: (item: any, index: number) => string | number;
    
    children?: ((item: any, index: number) => React.ReactNode) | React.ReactNode;

    fetchData?: () => void;
    post?: string;

    className?:string
    customStyle?:React.CSSProperties
    showEmptyText?:boolean
    showInfo?:boolean
    writeable?:boolean
    editPage?: editPageTypes

    setIsFirstRender?:React.Dispatch<React.SetStateAction<boolean>>
    loading?:boolean
}

const ListV2 = React.forwardRef<HTMLUListElement, ListV2Props>((props, ref) => {
    const {
        type = "default",
        list = [],
        setContent,

        renderItem,
        keyExtractor,

        children,

        fetchData,
        post,

        className,
        customStyle,
        showEmptyText = true,
        showInfo = true,
        writeable = false,
        editPage,
        setIsFirstRender,
        loading,
        ...rest
  } = props;

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    const { user } = useContext(AuthContext)
    const childIsRenderFn = typeof children === "function";
    const [editView, setEditView] = useState<boolean>(false)
    const [editContent, setEditContent] = useState<any>()
    
    const lastItemRef = useRef<HTMLLIElement | null>(null);
    const [endSet, setEndSet] = useState<boolean>(false)
        
    // useEffect(() => {
    //     // alert(type)
    //     console.log(list);
    // }, [type])

    const _key = (item: any, idx: number) => {
        if (keyExtractor) return keyExtractor(item, idx);
        if (item && (item.id || item._id)) return item.id ?? item._id;
        if (typeof item === "string" || typeof item === "number") return String(item);
        return idx;
    };

    const clickList= (id:number)=>{
        setEditView(false)
        setContent(id)
        if(setIsFirstRender) setIsFirstRender(true)
    }
    
    useEffect(() => {
        if (lastItemRef.current) {
            setEndSet(true);
        }
    }, [list]);



    return (
        <>
        
            <div className={`loadingWrapper`}>
                {loading &&
                    <div className={`loadingObj ${loading ? "show" : ""}`}>
                        <div>
                            <Lottie loop animationData={loadingJson} play style={{ maxWidth: "400px", margin: "0 auto" }} />
                        </div>
                    </div>
                }
        
                {
                    writeable && editView
                    && <EditView post={post ?? ""}
                        editContent={""}
                        setSelectContent={setContent}
                        setEditView={setEditView}
                        fetchData={fetchData ?? (() => {})}
                        editPage={editPage as editPageTypes} />
                }
                {
                    // endSet && writeable && user.is_authenticated && !editView
                     writeable && user.is_authenticated && !editView
                    && <div className="btns">
                        <div></div>
                        <div>
                            <button onClick={e => {
                                setContent(undefined)
                                setEditContent(undefined)
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                setEditView(true)
                            }}
                            className={`writeBtn`}>{t("글쓰기")}</button>
                        </div>
                    </div>
                } 
            
                <ul ref={ref} className={`listV2 ${className ?? ""} ${list.length == 0 ? "empty" : "" }`} 
                                style={customStyle?? undefined} {...rest}>
                { list && list.length ?
                    (
                        list.map((li, index) => {
                            

                            const key = _key(li, index);
                            // const thumb = type === "thumbnail" ? getThumbnail(li) : false ;
                            const thumb = getThumbnail(li);

                            // children이 함수형일 때: 강제 단언하여 호출
                            if (childIsRenderFn) {
                                return (
                                <li key={key} onClick={() => { clickList(li.id); }} ref={index === list.length - 1 ? lastItemRef : null}>
                                    { (children as (item:any, idx:number) => React.ReactNode)(li, index) }
                                </li>
                                );
                            }

                            // renderItem prop 이 제공되면 사용
                            if (renderItem) {
                                return (
                                    <li key={key} onClick={() => { clickList(li.id); }} ref={index === list.length - 1 ? lastItemRef : null}>
                                    { renderItem(li, index) }
                                    </li>
                                );
                            }

                            // 기본 템플릿
                            return (
                            <li key={key} 
                                onClick={() => { clickList(li.id); }}
                                ref={index === list.length - 1 ? lastItemRef : null}
                                className={`flex start ${type === "thumbnail" ? "thumbnail" :""}`}>

                                {type === "thumbnail"  && thumb && (
                                    <div className="thumbnailArea">
                                        <img src={thumb} 
                                            alt="thumbnail"
                                            className={`thumbnail`}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null; // 무한 루프 방지
                                                e.currentTarget.src = defaultThumbnail.src;
                                            }} />
                                    </div>
                                )}

                                <div className="contentsArea">
                                    <div className="info">
                                        <div className={`subject`}>
                                            {/* {li.title} */}
                                            {/* <div dangerouslySetInnerHTML={{__html: li.title}}></div> */}
                                            <div dangerouslySetInnerHTML={{ __html: String(li.title ?? "") }}
                                                 suppressHydrationWarning ></div>
                                        </div>
                                        <div className={` auth`}>
                                            <div className={`m-r-10`}>{t("작성자")} : {li.author_name || li.author_username}</div>
                                            <div>{t("작성일")} : {moment(li.create_dt).format('MM-DD')}</div>
                                        </div>
                                    </div>
                                    {showInfo &&
                                    <div className="etc">
                                        <BoardListInfo 
                                            comment={li.comments && li.comments.length>0  ? with_comma(li.comments.length) :undefined}
                                            thumbs={li.like_count ? with_comma(li.like_count) : undefined} />
                                    </div>
                                    }
                                </div>
                            </li>
                            );

                        })

                    ) : !loading && showEmptyText && <li className="empty">{a("InvalidSearchData")}</li>
                }
                </ul>
            </div>
        </>
    );
});

ListV2.displayName = "ListV2";
export default ListV2;
